import { Box, Text } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

const MESSAGE_BUBBLE_WIDTH = 'calc(100% - 42px)'

export const AgentMessageStyledBox = styled(Box)`
  ${s({
    bgcolor: 'colorBackground02',
    p: 6,
    pr: 8,
    mr: 10,
    mb: 6,
    borderRadius: 'borderRadius02',
  })}

  border-bottom-left-radius: 0;
  width: fit-content;
  max-width: ${MESSAGE_BUBBLE_WIDTH};
  margin-left: 0;
`

export const AgentMessageText = styled(Text)`
  ${s({
    typography: 'typeBodyText',
    color: 'colorTextHeadline',
    mb: 0,
  })}
`
